import * as mt from "./mutation-types";
import { RootState } from "../types";
import { CropsState, CropsPayload } from "./types";
import { ActionContext } from "vuex";

export default {
  [mt.CLEANUP]({ commit }: ActionContext<CropsState, RootState>) {
    commit(mt.CLEANUP);
  },
  [mt.CROPS_REQUEST_SUCCESS](
    { commit }: ActionContext<CropsState, RootState>,
    payload: CropsPayload
  ) {
    commit(mt.CROPS_REQUEST_SUCCESS, payload);
  },
};
